import { Box, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { useBoundStore } from 'useStore';
import { formatearNumeroConComas } from 'views/Components/Shared/utils/formatNumbers';
import { useShallow } from 'zustand/react/shallow';

const ColumnNumberField = memo(
	({ value, id, field, prefix, suffix, editable, row }) => {
		const editedValue = useBoundStore(
			useShallow((state) => state.pricingEditedRows[id]?.[field])
		);

		const currentValue = editedValue ?? value;

		if (editable && (currentValue === 0 || currentValue === undefined)) {
			return (
				<Box
					sx={{
						height: '100%',
						width: '100%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<Typography sx={{ color: '#D2D2D2' }}>$0.00</Typography>
				</Box>
			);
		}

		return <FieldNumber value={currentValue} prefix={prefix} suffix={suffix} />;
	}
);

export default ColumnNumberField;

const FieldNumber = memo(({ value, prefix, suffix }) => {
	return (
		<Stack
			spacing="0px"
			sx={{
				alignItems: 'center',
				justifyContent: 'center',
				height: '100%',
			}}
		>
			<Typography>
				{prefix}

				{formatearNumeroConComas(value)}

				{suffix}
			</Typography>
		</Stack>
	);
});
